"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStandingForElectricity = exports.mapConsumptionsWithSPRNandFriendlyLabel = void 0;
var readingSortOrder = {
    Anytime: 0,
    Peak: 1,
    Offpeak: 2,
    Evening_and_weekend: 3,
    Heating: 4,
};
var isFriendlyLabel = function (value) {
    return ['Anytime', 'Heating', 'Peak', 'Offpeak', 'Evening_and_weekend'].includes(value);
};
var sortRegistersByFriendlyLabels = function (a, b) {
    if (isFriendlyLabel(a.friendlyLabel) && isFriendlyLabel(b.friendlyLabel)) {
        return (readingSortOrder[a.friendlyLabel] - readingSortOrder[b.friendlyLabel]);
    }
    return 0;
};
var getUniqueFriendlyLabels = function (rates) {
    return rates.reduce(function (acc, _a) {
        var friendlyLabel = _a.friendlyLabel;
        if (!acc.includes(friendlyLabel)) {
            acc.push(friendlyLabel);
        }
        return acc;
    }, []);
};
var flattenConsumptionMap = function (prev, curr) {
    return prev.concat(curr);
};
var mapConsumptionsWithSPRNandFriendlyLabel = function (electricityCharges) {
    return electricityCharges
        .map(function (supplyPoint) {
        var uniqueFriendlyLabels = getUniqueFriendlyLabels(supplyPoint.consumption.rates);
        return uniqueFriendlyLabels.map(function (friendlyLabel) { return ({
            sprn: supplyPoint.sprn,
            friendlyLabel: friendlyLabel,
            consumptionRates: supplyPoint.consumption.rates.filter(function (register) { return register.friendlyLabel === friendlyLabel; }),
            isMultiRate: electricityCharges.length > 1 || uniqueFriendlyLabels.length > 1
                ? true
                : false,
        }); });
    })
        .reduce(flattenConsumptionMap, [])
        .sort(sortRegistersByFriendlyLabels);
};
exports.mapConsumptionsWithSPRNandFriendlyLabel = mapConsumptionsWithSPRNandFriendlyLabel;
var getStandingForElectricity = function (electricityCharges) {
    var _a;
    return electricityCharges
        ? (_a = electricityCharges.find(function (electricityRegisterCharges) { return electricityRegisterCharges.standing; })) === null || _a === void 0 ? void 0 : _a.standing
        : undefined;
};
exports.getStandingForElectricity = getStandingForElectricity;
